import React, { FC, useCallback, useEffect, useState } from 'react';
import { Image, TouchableOpacity, View } from 'react-native';
import { RootState } from '../../../services/redux/store';
import { homeStyles } from '../styles';
import { Text } from '../../../components/Text/Text';
import { format } from 'date-fns';
import { STYLE_VARS } from '../../../constants/style-vars';
import { DASHBOARD_DESTOP_MENU } from '../constants';
import { useNavigation } from '@react-navigation/native';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchDate,
  fetchWeather,
} from '../../../services/redux/reducers/ActionCreators';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import Sidebar from '../../../components/Sidebar';
import { FONTS } from '../../../constants';
import { NavigationService } from '../../../services/navigation';

export const User: FC = () => {
  const dispatch: ThunkDispatch<RootState, void, AnyAction> = useDispatch();

  const { dateData } = useSelector((state: RootState) => state?.dateReducer);
  const { info, loggedin } = useSelector(
    (redux: RootState) => redux.authReducer
  );
  const { weatherData, icon } = useSelector(
    (state: RootState) => state?.weatherReducer
  );

  useEffect(() => {
    dispatch(fetchDate());
    dispatch(fetchWeather());
  }, [dispatch]);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }
    return format(date, 'EEEE MMMM do');
  };

  const { user } = useSelector((redux: RootState) => ({
    user: redux.user.data,
  }));

  const isDesktop = useIsDesktop();

  if (isDesktop()) {
    return (
      <View style={{ width: '20%', minWidth: 230 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <TouchableOpacity
            onPress={() => {
              NavigationService.push('Root', {
                screen: 'MyAccountTab',
              });
            }}
          >
            <Image
              source={
                info?.avatar
                  ? { uri: info?.avatar }
                  : require('../../../assets/avatar.png')
              }
              style={{ width: 80, height: 80, borderRadius: 100 }}
            />
          </TouchableOpacity>

          <View style={{ paddingLeft: 10 }}>
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: 4,
              }}
            >
              <View
                style={{
                  width: 20,
                  height: 1,
                  backgroundColor: STYLE_VARS.primaryColor,
                }}
              />
              <Text
                style={{
                  paddingHorizontal: 2,
                  fontFamily: FONTS.IowanOldStyleBTRoman,
                  color: STYLE_VARS.primaryColor,
                }}
              >
                WELCOME
              </Text>
              <View
                style={{
                  width: 20,
                  height: 1,
                  backgroundColor: STYLE_VARS.primaryColor,
                }}
              />
            </View>

            <Text
              style={{
                fontFamily: FONTS.IowanOldStyleBTRoman,
                color: STYLE_VARS.primaryColor,
                fontSize: 16,
                marginBottom: 2,
                textTransform: 'uppercase',
              }}
            >
              {info?.display_name && info.display_name.length > 0
                ? info.display_name
                : info?.user_login}
            </Text>
            <Text
              style={{
                fontFamily: FONTS.IowanOldStyleBTRoman,
                color: STYLE_VARS.primaryColor,
                fontSize: 16,
                marginBottom: 4,
              }}
            >
              #{info?.mbnum}
            </Text>
            <View
              style={{
                backgroundColor: STYLE_VARS.primaryColor,
                padding: 3,
                borderRadius: 5,
                alignItems: 'center',
              }}
            >
              <Text
                style={{
                  color: 'white',
                  fontFamily: FONTS.IowanOldStyleBTRoman,
                  fontStyle: 'italic',
                  fontSize: 12,
                  textTransform: 'uppercase',
                }}
              >
                {info?.member_type}
              </Text>
            </View>
          </View>
        </View>

        <View
          style={{ flexDirection: 'row', alignItems: 'center', marginTop: 16 }}
        >
          <Text
            style={{
              fontSize: 14,
              color: STYLE_VARS.primaryColor,
              flex: 1,
              fontFamily: FONTS.IowanOldStyleBTRoman,
              textTransform: 'uppercase',
            }}
          >
            {formatDate(dateData?.datetime)}
          </Text>

          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Image
              source={icon}
              style={{
                width: 20,
                height: 20,
                marginRight: 6,
                tintColor: STYLE_VARS.primaryColor,
              }}
            />
            <Text
              style={[
                homeStyles.userName,
                { fontFamily: FONTS.IowanOldStyleBTRoman },
              ]}
            >
              {weatherData?.current_weather?.temperature}˚
            </Text>
          </View>
        </View>

        <View
          style={{ marginTop: 30, backgroundColor: STYLE_VARS.fccLightGrey }}
        >
          <Sidebar
            data={DASHBOARD_DESTOP_MENU}
            current={-1}
            //handlePressItem={navigateToLogin}
          />
        </View>
      </View>
    );
  }

  return (
    <View style={homeStyles.menuuserwrap}>
      <View style={homeStyles.menuuserinfo}>
        {loggedin && (
          <>
            <Text style={[homeStyles.userName, { marginBottom: 6 }]}>
              WELCOME
            </Text>
            <Text style={[homeStyles.userName, { textTransform: 'uppercase' }]}>
              {info?.display_name && info.display_name.length > 0
                ? info.display_name
                : info?.user_login}
            </Text>
          </>
        )}
      </View>

      <View style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
        <Text style={{ fontSize: 13, marginBottom: 6 }}>
          {formatDate(new Date().toString())}
        </Text>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <Image
            source={icon}
            style={{
              width: 20,
              height: 20,
              marginRight: 2,
              tintColor: STYLE_VARS.primaryColor,
            }}
          />
          <Text
            style={[
              homeStyles.userName,
              { fontFamily: FONTS.IowanOldStyleBTRoman },
            ]}
          >
            {weatherData?.current_weather?.temperature}˚
          </Text>
        </View>
      </View>
    </View>
  );
};
